'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _SongsSelectButton = require('components/SongsSelectButton/SongsSelectButton');

var _SongsSelectButton2 = _interopRequireDefault(_SongsSelectButton);

var _BackButton = require('components/BackButton/BackButton');

var _BackButton2 = _interopRequireDefault(_BackButton);

var _MyPlaylistInfo = require('containers/MyPlaylist/components/MyPlaylistInfo');

var _MyPlaylistInfo2 = _interopRequireDefault(_MyPlaylistInfo);

var _myPlaylists = require('redux/modules/my-playlists');

var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);

var _playlists = require('redux/modules/playlists');

var playlistsActions = _interopRequireWildcard(_playlists);

var _myPlaylists2 = require('selectors/my-playlists');

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _Page = require('components/Page/Page');

var _Page2 = _interopRequireDefault(_Page);

var _MyPlaylistTracks = require('containers/MyPlaylist/components/MyPlaylistTracks');

var _MyPlaylistTracks2 = _interopRequireDefault(_MyPlaylistTracks);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./MyPlaylist.scss');

var MyPlaylist = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    if (!dispatch(myPlaylistsActions.isLoaded())) {
      promises.push(dispatch(myPlaylistsActions.loadMyPlaylists()).promise);
    }
    if (!dispatch(playlistsActions.isLoaded())) {
      promises.push(dispatch(playlistsActions.loadPlaylists()).promise);
    }
    return (0, _asyncPromise2.default)(_promise2.default.all(promises).catch(function (err) {
      return err;
    }));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    addTracksActionData: state.myPlaylists.addMyPlaylistTracksActionData,
    addTracksLoading: state.myPlaylists.addMyPlaylistTracksLoading,
    myPlaylistId: ownProps.params.myPlaylistId,
    myPlaylistsLoading: state.myPlaylists.myPlaylistsLoading,
    playlist: (0, _myPlaylists2.getMyPlaylist)(state, ownProps.params.myPlaylistId),
    playlistsLoading: state.playlists.playlistsLoading,
    tracks: (0, _myPlaylists2.getMyPlaylisTracks)(state, ownProps.params.myPlaylistId)
  };
}, (0, _extends3.default)({}, myPlaylistsActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(MyPlaylist, _Component);

  function MyPlaylist() {
    (0, _classCallCheck3.default)(this, MyPlaylist);
    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylist.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylist)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyPlaylist, [{
    key: 'onAddSongs',
    value: function onAddSongs(tracksId) {
      var _props = this.props,
          addMyPlaylistTracks = _props.addMyPlaylistTracks,
          playlist = _props.playlist;

      return addMyPlaylistTracks({ guids: [playlist.guid], tracksId: tracksId });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          playlist = _props2.playlist,
          myPlaylistsLoading = _props2.myPlaylistsLoading,
          tracks = _props2.tracks,
          addTracksLoading = _props2.addTracksLoading,
          addTracksActionData = _props2.addTracksActionData,
          playlistsLoading = _props2.playlistsLoading;

      var isAdding = addTracksLoading && addTracksActionData.guids.includes(playlist.guid);
      var isListLoading = isAdding || playlistsLoading;
      var title = t('My Playlist');

      return _react2.default.createElement(
        _Page2.default,
        { title: title, header: title },
        _react2.default.createElement(
          'div',
          { className: styles.headLine },
          _react2.default.createElement(_BackButton2.default, null),
          _react2.default.createElement(_SongsSelectButton2.default, { onSave: this.onAddSongs })
        ),
        myPlaylistsLoading ? _react2.default.createElement(_Loader2.default, { alignCenter: true }) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_MyPlaylistInfo2.default, {
            className: styles.info,
            playlist: playlist,
            tracksCount: tracks.length
          }),
          _react2.default.createElement(_MyPlaylistTracks2.default, {
            playlist: playlist,
            tracks: tracks,
            loading: isListLoading
          })
        )
      );
    }
  }]);
  return MyPlaylist;
}(_react.Component), _class3.propTypes = {
  addMyPlaylistTracks: _propTypes2.default.func,
  addTracksActionData: _propTypes2.default.object,
  addTracksLoading: _propTypes2.default.bool,
  myPlaylistsLoading: _propTypes2.default.bool,
  playlist: _propTypes2.default.object,
  playlistsLoading: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  tracks: _propTypes2.default.array
}, _class3.defaultProps = {
  addTracksActionData: {},
  playlist: {},
  tracks: []
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onAddSongs', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onAddSongs'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = MyPlaylist;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylist/MyPlaylist.js
// module id = 2162
// module chunks = 1